import React from "react";
import { IMAGE_WIDTH } from "../../../constants/FIB";
import { getDefaultWidthInputByFontSize } from "edu_lms_v2/libraries/hoc10Game/helpers/FIB_BG";
import styles from "./styles.module.scss";

const InputPositionV1 = React.forwardRef(
	({ widthForm, fontSize, color, position, showResult, ...props }, ref) => {
		const fontSizeScaled = fontSize * (widthForm / IMAGE_WIDTH.WebView);
		const top = ((widthForm || IMAGE_WIDTH.WebView) / IMAGE_WIDTH.CMSView) * position.vertical_axis_px;
		const left = ((widthForm || IMAGE_WIDTH.WebView) / IMAGE_WIDTH.CMSView) * position.horizontal_axis_px;
		
		return (
			<>
        {showResult && (
	        <style>
		        {`
              .input-placeholder-red::placeholder {
               font-size: 16px;
               color: #ff7707;
              }
            `}
	        </style>
        )}
	        
	        <input
		        {...props}
		        ref={ref}
		        type="text"
		        className={`monkey-fz-20 quicksand-medium ${styles["input-position-v1"]} ${
			        showResult ? "input-placeholder-red" : ""
		        }`}
		        style={{
			        fontSize: `${fontSizeScaled}px`,
			        width: `${getDefaultWidthInputByFontSize(fontSize)}px`,
			        color: color,
			        top,
			        left,
		        }}
		        placeholder={showResult ? ("(" + position.order +")") : "?"}
		        autoComplete="off"
	        />
			</>
		);
	}
);

export default InputPositionV1;
